import { useState, useEffect } from 'react'
import { supabase, storage } from '../../lib/supabase'
import LoadingSpinner from '../../components/LoadingSpinner'

export default function Eventos() {
  const [eventos, setEventos] = useState([])
  const [categorias, setCategorias] = useState([])
  const [tiendas, setTiendas] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [showInscritosModal, setShowInscritosModal] = useState(false)
  const [selectedEvento, setSelectedEvento] = useState(null)
  const [inscritos, setInscritos] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedEstado, setSelectedEstado] = useState('')
  const [selectedPublicado, setSelectedPublicado] = useState('')

  useEffect(() => {
    fetchCategorias()
    fetchTiendas()
    fetchEventos()
  }, [])

  const fetchCategorias = async () => {
    const { data } = await supabase
      .from('categorias')
      .select('*')
      .eq('tipo', 'Evento')
      .order('nombre')
    setCategorias(data || [])
  }

  const fetchTiendas = async () => {
    const { data } = await supabase
      .from('tiendas')
      .select('id, nombre, logo_url, publicado')
      .order('nombre')
    setTiendas(data || [])
  }

  const fetchEventos = async () => {
    try {
      setLoading(true)
      const { data, error } = await supabase
        .from('eventos')
        .select(`
          *,
          categorias(nombre)
        `)
        .order('fecha_inicio', { ascending: false })

      if (error) throw error
      setEventos(data || [])
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setLoading(false)
    }
  }

  const fetchInscritos = async (eventoId) => {
    const { data } = await supabase
      .from('inscripciones_eventos')
      .select('*')
      .eq('evento_id', eventoId)
      .order('created_at', { ascending: false })
    setInscritos(data || [])
  }

  const handleDelete = async (id) => {
    if (!confirm('¿Estás seguro de eliminar este evento?')) return
    
    const { error } = await supabase
      .from('eventos')
      .delete()
      .eq('id', id)
    
    if (!error) {
      fetchEventos()
      alert('Evento eliminado exitosamente')
    }
  }

  const togglePublicado = async (id, currentState) => {
    const { error } = await supabase
      .from('eventos')
      .update({ publicado: !currentState })
      .eq('id', id)

    if (!error) {
      fetchEventos()
    }
  }

  const openInscritosModal = async (evento) => {
    setSelectedEvento(evento)
    await fetchInscritos(evento.id)
    setShowInscritosModal(true)
  }

  const exportToCSV = () => {
    if (inscritos.length === 0) return

    const headers = ['Nombre', 'Email', 'WhatsApp', 'Fecha de Inscripción']
    const rows = inscritos.map(i => [
      i.usuario_nombre,
      i.usuario_email,
      i.usuario_whatsapp || '',
      new Date(i.created_at).toLocaleDateString('es-PE')
    ])

    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
    ].join('\n')

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = `inscritos_${selectedEvento.nombre.replace(/\s+/g, '_')}.csv`
    link.click()
  }

  const filteredEventos = eventos.filter(evento => {
    const matchesSearch = evento.nombre.toLowerCase().includes(searchTerm.toLowerCase())
    const matchesEstado = !selectedEstado || evento.estado === selectedEstado
    const matchesPublicado = !selectedPublicado || (selectedPublicado === 'publicado' ? evento.publicado : !evento.publicado)
    return matchesSearch && matchesEstado && matchesPublicado
  })

  const getEstadoBadge = (estado) => {
    const colors = {
      'Próximo': 'bg-blue-100 text-blue-800',
      'Activo': 'bg-green-100 text-green-800',
      'Finalizado': 'bg-gray-100 text-gray-800'
    }
    return colors[estado] || 'bg-gray-100 text-gray-800'
  }

  return (
    <div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '1.5rem'
      }}>
        <h1 style={{
          fontSize: 'var(--h1)',
          fontWeight: '700',
          fontFamily: 'var(--font-display)',
          color: 'var(--textPrimary)'
        }}>EVENTOS</h1>
        <button
          onClick={() => {
            setSelectedEvento(null)
            setShowModal(true)
          }}
          style={{
            padding: '0.75rem 1.5rem',
            background: 'var(--ctaBg)',
            color: 'var(--ctaText)',
            border: 'none',
            borderRadius: 'var(--radius-md)',
            fontSize: 'var(--body)',
            fontWeight: '600',
            fontFamily: 'var(--font-ui)',
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'var(--accentPurpleDark)'
            e.currentTarget.style.transform = 'translateY(-2px)'
            e.currentTarget.style.boxShadow = 'none'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'var(--ctaBg)'
            e.currentTarget.style.transform = 'translateY(0)'
            e.currentTarget.style.boxShadow = 'none'
          }}
        >
          + Nuevo Evento
        </button>
      </div>

      {/* Filtros */}
      <div style={{
        background: 'var(--surface)',
        padding: '1.5rem',
        borderRadius: 'var(--radius-lg)',
        boxShadow: 'none',
        border: 'var(--card-border)',
        marginBottom: '1.5rem'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '1rem'
        }}>
          <input
            type="text"
            placeholder="Buscar evento..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              padding: '0.75rem 1rem',
              border: '1px solid var(--mutedStroke)',
              borderRadius: 'var(--radius-md)',
              fontSize: 'var(--body)',
              fontFamily: 'var(--font-ui)',
              color: 'var(--textPrimary)',
              transition: 'border-color 0.2s ease, box-shadow 0.2s ease'
            }}
            onFocus={(e) => {
              e.currentTarget.style.outline = 'none'
              e.currentTarget.style.borderColor = 'var(--accentPurple)'
              e.currentTarget.style.boxShadow = 'none'
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = 'var(--mutedStroke)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          />
          <select
            value={selectedEstado}
            onChange={(e) => setSelectedEstado(e.target.value)}
            style={{
              padding: '0.75rem 1rem',
              border: '1px solid var(--mutedStroke)',
              borderRadius: 'var(--radius-md)',
              fontSize: 'var(--body)',
              fontFamily: 'var(--font-ui)',
              color: 'var(--textPrimary)',
              transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
              cursor: 'pointer'
            }}
            onFocus={(e) => {
              e.currentTarget.style.outline = 'none'
              e.currentTarget.style.borderColor = 'var(--accentPurple)'
              e.currentTarget.style.boxShadow = 'none'
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = 'var(--mutedStroke)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          >
            <option value="">Todos los estados</option>
            <option value="Próximo">Próximo</option>
            <option value="Activo">Activo</option>
            <option value="Finalizado">Finalizado</option>
          </select>
          <select
            value={selectedPublicado}
            onChange={(e) => setSelectedPublicado(e.target.value)}
            style={{
              padding: '0.75rem 1rem',
              border: '1px solid var(--mutedStroke)',
              borderRadius: 'var(--radius-md)',
              fontSize: 'var(--body)',
              fontFamily: 'var(--font-ui)',
              color: 'var(--textPrimary)',
              transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
              cursor: 'pointer'
            }}
            onFocus={(e) => {
              e.currentTarget.style.outline = 'none'
              e.currentTarget.style.borderColor = 'var(--accentPurple)'
              e.currentTarget.style.boxShadow = 'none'
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = 'var(--mutedStroke)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          >
            <option value="">Todos (Publicado/Borrador)</option>
            <option value="publicado">Publicados</option>
            <option value="borrador">Borradores</option>
          </select>
        </div>
      </div>

      {/* Tabla de Eventos */}
      <div style={{
        background: 'var(--surface)',
        borderRadius: 'var(--radius-lg)',
        boxShadow: 'none',
        border: 'var(--card-border)',
        overflow: 'hidden'
      }}>
        {loading ? (
          <div style={{
            textAlign: 'center',
            padding: '3rem'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              border: '3px solid var(--background)',
              borderTop: '3px solid var(--accentPurple)',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '0 auto 1rem'
            }}></div>
            <p style={{
              fontSize: 'var(--body)',
              fontFamily: 'var(--font-ui)',
              color: 'var(--textMuted)'
            }}>Cargando...</p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Publicación</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Evento</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Categoría</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Fechas</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Estado</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Inscripción</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Acciones</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredEventos.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="px-6 py-12 text-center text-gray-500">
                      No se encontraron eventos
                    </td>
                  </tr>
                ) : (
                  filteredEventos.map((evento) => (
                    <tr key={evento.id} className="hover:bg-gray-50">
                      <td className="px-6 py-4">
                        <button
                          onClick={() => togglePublicado(evento.id, evento.publicado)}
                          className={`px-3 py-1 rounded-full text-xs font-semibold ${
                            evento.publicado
                              ? 'bg-green-100 text-green-800'
                              : 'bg-gray-200 text-gray-700'
                          }`}
                        >
                          {evento.publicado ? '✓ Publicado' : '📝 Borrador'}
                        </button>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-3">
                          {evento.imagen_url && (
                            <img src={evento.imagen_url} alt={evento.nombre || 'Imagen del evento'}
 className="h-12 w-12 object-cover rounded" />
                          )}
                          <div>
                            <div className="font-medium">{evento.nombre}</div>
                            {evento.etiqueta && (
                              <span className="text-xs bg-orange-100 text-orange-800 px-2 py-0.5 rounded">
                                {evento.etiqueta}
                              </span>
                            )}
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 text-sm">{evento.categorias?.nombre || '-'}</td>
                      <td className="px-6 py-4 text-sm">
                        {evento.fecha_inicio && new Date(evento.fecha_inicio).toLocaleDateString('es-PE')}
                        {evento.fecha_fin && (
                          <>
                            <br />
                            <span className="text-gray-500">hasta {new Date(evento.fecha_fin).toLocaleDateString('es-PE')}</span>
                          </>
                        )}
                      </td>
                      <td className="px-6 py-4">
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${getEstadoBadge(evento.estado)}`}>
                          {evento.estado}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-center">
                        {evento.confirmar_asistencia ? (
                          <span className="text-green-600">✔ Activa</span>
                        ) : (
                          <span className="text-gray-400">✖ Desactivada</span>
                        )}
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex gap-2">
                          <button
                            onClick={() => openInscritosModal(evento)}
                            className="text-purple-600 hover:text-purple-800 text-sm"
                            title="Ver inscritos"
                          >
                            📋
                          </button>
                          <button
                            onClick={() => {
                              setSelectedEvento(evento)
                              setShowModal(true)
                            }}
                            className="text-blue-600 hover:text-blue-800 text-sm"
                          >
                            Editar
                          </button>
                          <button
                            onClick={() => handleDelete(evento.id)}
                            className="text-red-600 hover:text-red-800 text-sm"
                          >
                            Eliminar
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal CRUD */}
      {showModal && (
        <EventoFormModal
          evento={selectedEvento}
          categorias={categorias}
          tiendas={tiendas}
          onClose={() => {
            setShowModal(false)
            setSelectedEvento(null)
          }}
          onSuccess={() => {
            setShowModal(false)
            setSelectedEvento(null)
            fetchEventos()
          }}
        />
      )}

      {/* Modal Inscritos */}
      {showInscritosModal && (
        <InscritosModal
          evento={selectedEvento}
          inscritos={inscritos}
          onClose={() => setShowInscritosModal(false)}
          onExport={exportToCSV}
        />
      )}
    </div>
  )
}

// Modal para crear/editar evento
function EventoFormModal({ evento, categorias, tiendas, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    nombre: evento?.nombre || '',
    descripcion: evento?.descripcion || '',
    categoria_id: evento?.categoria_id || '',
    estado: evento?.estado || 'Próximo',
    etiqueta: evento?.etiqueta || '',
    imagen_url: evento?.imagen_url || '',
    fecha_inicio: evento?.fecha_inicio || '',
    fecha_fin: evento?.fecha_fin || '',
    horario: evento?.horario || '',
    lugar: evento?.lugar || '',
    piso: evento?.piso || '',
    confirmar_asistencia: evento?.confirmar_asistencia || false,
    publicado: evento?.publicado !== undefined ? evento.publicado : true,
    mostrar_en_home: evento?.mostrar_en_home || false,
    // SEO fields
    seo_title: evento?.seo_title || '',
    seo_description: evento?.seo_description || '',
    og_image_url: evento?.og_image_url || '',
    robots_index: evento?.robots_index !== undefined ? evento.robots_index : true,
    json_ld: evento?.json_ld || '',
    imagen_alt_text: evento?.imagen_alt_text || '',
  })
  const [submitting, setSubmitting] = useState(false)
  const [bannerFile, setBannerFile] = useState(null)
  const [bannerPreview, setBannerPreview] = useState(evento?.imagen_url || '')
  const [participants, setParticipants] = useState([])
  const [selectedTiendaId, setSelectedTiendaId] = useState('')

  const handleBannerChange = (e) => {
    const file = e.target.files?.[0]
    if (!file) {
      setBannerFile(null)
      setBannerPreview('')
      return
    }
    setBannerFile(file)
    const previewUrl = URL.createObjectURL(file)
    setBannerPreview(previewUrl)
  }

  // Load existing participants when editing
  useEffect(() => {
    const loadParticipants = async () => {
      if (!evento?.id) return
      const { data } = await supabase
        .from('eventos_tiendas')
        .select('*')
        .eq('evento_id', evento.id)
      setParticipants(data || [])
    }
    loadParticipants()
  }, [evento])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitting(true)

    try {
      // Guard: Check if user is trying to mark as mostrar_en_home
      if (formData.mostrar_en_home && formData.publicado && ['Próximo', 'Activo'].includes(formData.estado)) {
        // Check how many events are already marked
        const { data: alreadyMarked } = await supabase
          .from('eventos')
          .select('id')
          .eq('mostrar_en_home', true)
          .eq('publicado', true)
          .in('estado', ['Próximo', 'Activo'])
        
        // Filter out the current event if editing
        const otherMarked = (alreadyMarked || []).filter(e => e.id !== (evento?.id || null))
        
        if (otherMarked.length >= 2) {
          alert('Solo puedes marcar 2 eventos vigentes para mostrar en el Home. Desmarca otro evento primero.')
          setSubmitting(false)
          return
        }
      }

      // Clean up form data - convert empty strings to null for UUID and date fields
      const cleanedData = {
        ...formData,
        categoria_id: formData.categoria_id || null,
        fecha_inicio: formData.fecha_inicio || null,
        fecha_fin: formData.fecha_fin || null,
        mostrar_en_home: !!formData.mostrar_en_home
      }

      // Upload banner if a new file was selected
      if (bannerFile) {
        const safeName = bannerFile.name.replace(/\s+/g, '_')
        const path = `eventos/banners/${Date.now()}_${safeName}`
        const { error: uploadError } = await storage.uploadImage('assets', bannerFile, path)
        if (uploadError) throw uploadError
        const publicUrl = storage.getPublicUrl('assets', path)
        cleanedData.imagen_url = publicUrl
      }

      if (evento) {
        // Editar
        const { error } = await supabase
          .from('eventos')
          .update(cleanedData)
          .eq('id', evento.id)
        if (error) throw error
      } else {
        // Crear
        const { error } = await supabase
          .from('eventos')
          .insert([cleanedData])
        if (error) throw error
      }

      // Sync participants
      let eventoId = evento?.id
      if (!eventoId) {
        // Get the newly created evento ID
        const { data: created } = await supabase
          .from('eventos')
          .select('id')
          .order('created_at', { ascending: false })
          .limit(1)
        eventoId = created?.[0]?.id
      }

      if (eventoId) {
        // Load existing participants
        const { data: existingRows } = await supabase
          .from('eventos_tiendas')
          .select('*')
          .eq('evento_id', eventoId)

        const desiredMap = new Map(participants.map(p => [p.tienda_id, p.borrador]))
        const existingMap = new Map((existingRows || []).map(r => [r.tienda_id, r.borrador]))

        // Insert new participants
        for (const [tiendaId, borrador] of desiredMap.entries()) {
          if (!existingMap.has(tiendaId)) {
            await supabase
              .from('eventos_tiendas')
              .insert([{ evento_id: eventoId, tienda_id: tiendaId, borrador: borrador || false }])
          } else if (existingMap.get(tiendaId) !== borrador) {
            // Update borrador flag if changed
            await supabase
              .from('eventos_tiendas')
              .update({ borrador: borrador || false })
              .eq('evento_id', eventoId)
              .eq('tienda_id', tiendaId)
          }
        }

        // Delete removed participants
        for (const tiendaId of existingMap.keys()) {
          if (!desiredMap.has(tiendaId)) {
            await supabase
              .from('eventos_tiendas')
              .delete()
              .eq('evento_id', eventoId)
              .eq('tienda_id', tiendaId)
          }
        }
      }

      alert('Evento guardado exitosamente')
      onSuccess()
    } catch (error) {
      console.error('Error:', error)
      alert('Error al guardar el evento')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 overflow-y-auto" style={{ zIndex: 9999 }}>
      <div className="bg-white rounded-lg w-full my-8" style={{ maxWidth: window.innerWidth < 768 ? '100%' : '768px' }}>
        <div className="p-6 border-b flex justify-between items-center">
          <h2 className="text-2xl font-bold">{evento ? 'Editar' : 'Nuevo'} Evento</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl font-bold w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
            type="button"
          >
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 max-h-[70vh] overflow-y-auto">
          {/* Alert Info */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-blue-800">
              <strong>Estado de Publicación:</strong> Los eventos en "Borrador" solo son visibles en este panel de administración. 
              Marca como "Publicado" cuando esté listo para aparecer en el sitio web público.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Estado de publicación */}
            <div className="md:col-span-2">
              <label className="flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={formData.publicado}
                  onChange={(e) => setFormData({...formData, publicado: e.target.checked})}
                  className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <span className="ml-2 text-sm font-medium">
                  {formData.publicado ? '✅ Publicar en el sitio web' : '📝 Guardar como borrador'}
                </span>
              </label>
            </div>

            <div className="md:col-span-2">
              <label className="flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={formData.mostrar_en_home}
                  onChange={(e) => setFormData({...formData, mostrar_en_home: e.target.checked})}
                  className="w-4 h-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                />
                <span className="ml-2 text-sm font-medium">
                  🏠 Mostrar en Home (máx. 2 eventos vigentes)
                </span>
              </label>
              <p className="text-xs text-gray-500 mt-1 ml-6">
                Solo eventos publicados y vigentes (Próximo o Activo) pueden aparecer en la página de inicio.
              </p>
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-1">Nombre del Evento *</label>
              <input
                type="text"
                required
                value={formData.nombre}
                onChange={(e) => setFormData({...formData, nombre: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
              />
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-1">Descripción</label>
              <textarea
                rows={3}
                value={formData.descripcion}
                onChange={(e) => setFormData({...formData, descripcion: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Categoría</label>
              <select
                value={formData.categoria_id}
                onChange={(e) => setFormData({...formData, categoria_id: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
              >
                <option value="">Seleccionar categoría</option>
                {categorias.map(cat => (
                  <option key={cat.id} value={cat.id}>{cat.nombre}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Estado</label>
              <select
                value={formData.estado}
                onChange={(e) => setFormData({...formData, estado: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
              >
                <option value="Próximo">Próximo</option>
                <option value="Activo">Activo</option>
                <option value="Finalizado">Finalizado</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Etiqueta (opcional)</label>
              <input
                type="text"
                value={formData.etiqueta}
                onChange={(e) => setFormData({...formData, etiqueta: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
                placeholder="Ej: NUEVO, OFERTA"
              />
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-1">Banner del evento</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleBannerChange}
                className="w-full px-3 py-2 border rounded-lg"
              />
              {bannerPreview && (
                <div className="mt-3">
                  <img
                    src={bannerPreview}
                    alt="Vista previa del banner"
                    className="w-full h-48 object-cover rounded-lg border"
                  />
                </div>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Fecha de Inicio</label>
              <input
                type="date"
                value={formData.fecha_inicio}
                onChange={(e) => setFormData({...formData, fecha_inicio: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Fecha de Fin</label>
              <input
                type="date"
                value={formData.fecha_fin}
                onChange={(e) => setFormData({...formData, fecha_fin: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Horario</label>
              <input
                type="text"
                value={formData.horario}
                onChange={(e) => setFormData({...formData, horario: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
                placeholder="10AM - 8PM"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Lugar</label>
              <input
                type="text"
                value={formData.lugar}
                onChange={(e) => setFormData({...formData, lugar: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
                placeholder="Plaza Central"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Piso</label>
              <input
                type="text"
                value={formData.piso}
                onChange={(e) => setFormData({...formData, piso: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
                placeholder="Primer piso"
              />
            </div>

            <div className="md:col-span-2">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={formData.confirmar_asistencia}
                  onChange={(e) => setFormData({...formData, confirmar_asistencia: e.target.checked})}
                  className="w-4 h-4"
                />
                <span className="text-sm font-medium">Activar formulario de inscripción</span>
              </label>
            </div>

            {/* Sección SEO */}
            {evento && (
              <>
                <div className="md:col-span-2 border-t pt-4 mt-4">
                  <h3 className="font-bold text-lg mb-4">🔍 SEO y Meta Tags</h3>
                  <p className="text-sm text-gray-600 mb-4">Optimiza cómo aparece este evento en Google y redes sociales</p>

                  <div className="space-y-4">
                    {/* Alt Text del Banner */}
                    <div className="p-4 bg-gray-50 rounded-lg">
                      <h4 className="font-medium mb-3 text-sm">🖼️ Texto Alternativo del Banner (Accesibilidad & SEO)</h4>
                      <div>
                        <label className="block text-xs font-medium mb-1">Alt Text de la Imagen Principal</label>
                        <input
                          type="text"
                          value={formData.imagen_alt_text}
                          onChange={(e) => setFormData({...formData, imagen_alt_text: e.target.value})}
                          className="w-full px-3 py-2 border rounded text-sm"
                          placeholder={`Ej: Banner del evento ${formData.nombre}`}
                        />
                      </div>
                    </div>

                    {/* SEO Meta Tags */}
                    <div>
                      <label className="block text-xs font-medium mb-1">
                        Título SEO <span className="text-gray-500">(50-60 caracteres ideal)</span>
                      </label>
                      <input
                        type="text"
                        value={formData.seo_title}
                        onChange={(e) => setFormData({...formData, seo_title: e.target.value})}
                        className="w-full px-3 py-2 border rounded text-sm"
                        placeholder={`${formData.nombre} - Plaza Aurora`}
                        maxLength="70"
                      />
                      <p className="text-xs text-gray-500 mt-1">{formData.seo_title?.length || 0}/70 caracteres</p>
                    </div>

                    <div>
                      <label className="block text-xs font-medium mb-1">
                        Meta Description <span className="text-gray-500">(150-160 caracteres ideal)</span>
                      </label>
                      <textarea
                        value={formData.seo_description}
                        onChange={(e) => setFormData({...formData, seo_description: e.target.value})}
                        className="w-full px-3 py-2 border rounded text-sm"
                        rows={3}
                        placeholder="Descripción breve que aparecerá en Google y redes sociales"
                        maxLength="160"
                      />
                      <p className="text-xs text-gray-500 mt-1">{formData.seo_description?.length || 0}/160 caracteres</p>
                    </div>

                    <div>
                      <label className="block text-xs font-medium mb-1">
                        Imagen Open Graph (Redes Sociales) <span className="text-gray-500">(1200x630px recomendado)</span>
                      </label>
                      <input
                        type="url"
                        value={formData.og_image_url}
                        onChange={(e) => setFormData({...formData, og_image_url: e.target.value})}
                        className="w-full px-3 py-2 border rounded text-sm"
                        placeholder="URL completa de la imagen para compartir en redes"
                      />
                      {formData.og_image_url && (
                        <img src={formData.og_image_url} alt="Preview" className="mt-2 w-full max-w-sm h-32 object-cover rounded border" />
                      )}
                    </div>

                    <div>
                      <label className="block text-xs font-medium mb-1">
                        JSON-LD (Datos Estructurados) <span className="text-gray-500">(Avanzado - Opcional)</span>
                      </label>
                      <textarea
                        value={formData.json_ld}
                        onChange={(e) => setFormData({...formData, json_ld: e.target.value})}
                        className="w-full px-3 py-2 border rounded text-sm font-mono"
                        rows={4}
                        placeholder='{"@type": "Event", "name": "..."}'
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        💡 Dejar vacío para usar valores automáticos
                      </p>
                    </div>

                    <div>
                      <label className="flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={formData.robots_index}
                          onChange={(e) => setFormData({...formData, robots_index: e.target.checked})}
                          className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        />
                        <span className="ml-2 text-xs font-medium">
                          Permitir que Google indexe este evento (Recomendado)
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-2">Marcas participantes</label>
              <div className="flex gap-2">
                <select
                  value={selectedTiendaId}
                  onChange={(e) => setSelectedTiendaId(e.target.value)}
                  className="px-3 py-2 border rounded-lg flex-1"
                >
                  <option value="">Seleccionar tienda</option>
                  {tiendas.map(t => (
                    <option key={t.id} value={t.id}>
                      {t.nombre} {!t.publicado ? '(borrador)' : ''}
                    </option>
                  ))}
                </select>
                <button
                  type="button"
                  onClick={() => {
                    if (!selectedTiendaId) return
                    if (participants.some(p => p.tienda_id === selectedTiendaId)) {
                      alert('Esta tienda ya está agregada')
                      return
                    }
                    const tienda = tiendas.find(t => t.id === selectedTiendaId)
                    setParticipants([...participants, { tienda_id: selectedTiendaId, borrador: !tienda?.publicado }])
                    setSelectedTiendaId('')
                  }}
                  className="px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                >
                  + Agregar
                </button>
              </div>

              <div className="mt-3 space-y-2">
                {participants.length === 0 ? (
                  <p className="text-sm text-gray-500">No hay marcas participantes. Las marcas en borrador se mostrarán sin enlace.</p>
                ) : participants.map(p => {
                  const tienda = tiendas.find(t => t.id === p.tienda_id)
                  return (
                    <div key={p.tienda_id} className="flex items-center gap-3 border rounded-lg p-2">
                      {tienda?.logo_url && (
                        <img src={tienda.logo_url} alt={tienda?.nombre} className="h-8 w-8 object-contain" />
                      )}
                      <span className="flex-1 text-sm font-medium">{tienda?.nombre || p.tienda_id}</span>
                      <label className="flex items-center gap-1 text-xs">
                        <input
                          type="checkbox"
                          checked={!!p.borrador}
                          onChange={(e) => {
                            setParticipants(participants.map(pp => pp.tienda_id === p.tienda_id ? { ...pp, borrador: e.target.checked } : pp))
                          }}
                          className="w-3 h-3"
                        />
                        <span className="text-gray-600">Borrador (no clickeable)</span>
                      </label>
                      <button
                        type="button"
                        onClick={() => setParticipants(participants.filter(pp => pp.tienda_id !== p.tienda_id))}
                        className="text-xs px-2 py-1 bg-red-100 text-red-700 rounded hover:bg-red-200"
                      >
                        Quitar
                      </button>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-3 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border rounded-lg hover:bg-gray-50"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
            >
              {submitting ? 'Guardando...' : formData.publicado ? 'Guardar y Publicar' : 'Guardar Borrador'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

// Modal para ver inscritos
function InscritosModal({ evento, inscritos, onClose, onExport }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4" style={{ zIndex: 9999 }}>
      <div className="bg-white rounded-lg w-full max-h-[80vh] overflow-hidden" style={{ maxWidth: window.innerWidth < 768 ? '100%' : '768px' }}>
        <div className="p-6 border-b flex justify-between items-center">
          <div>
            <h2 className="text-2xl font-bold">Inscritos - {evento.nombre}</h2>
            <p className="text-sm text-gray-600 mt-1">Total: {inscritos.length} personas</p>
          </div>
          <div className="flex items-center gap-2">
            {inscritos.length > 0 && (
              <button
                onClick={onExport}
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 text-sm"
              >
                📄 Exportar CSV
              </button>
            )}
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 text-2xl font-bold w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
              type="button"
            >
              ×
            </button>
          </div>
        </div>
        
        <div className="p-6 overflow-y-auto max-h-96">
          {inscritos.length === 0 ? (
            <p className="text-center text-gray-500 py-8">No hay inscritos en este evento</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nombre</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Email</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">WhatsApp</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Fecha</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {inscritos.map((inscrito) => (
                    <tr key={inscrito.id}>
                      <td className="px-4 py-3 text-sm">{inscrito.usuario_nombre}</td>
                      <td className="px-4 py-3 text-sm">{inscrito.usuario_email}</td>
                      <td className="px-4 py-3 text-sm">{inscrito.usuario_whatsapp || '-'}</td>
                      <td className="px-4 py-3 text-sm">
                        {new Date(inscrito.created_at).toLocaleDateString('es-PE')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="p-6 border-t">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 border rounded-lg hover:bg-gray-50"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  )
}




